// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multi-select-container[data-v-255c7967]{display:flex;gap:40px}", ""]);
// Exports
module.exports = exports;
